var _path, _path2, _g, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5Start(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 170,
    viewBox: "0 0 171 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.048 74.2822C56.6829 74.2822 51.1006 74.9692 46.3085 76.3523L46.9811 66.2633H104.949H105.449V65.7633V30.627V30.127H104.949H11.7528H11.2834L11.2538 30.5954L6.1806 110.826L6.14699 111.358H6.6796H40.5007H40.729L40.8785 111.185C44.0206 107.56 48.5041 105.721 54.4049 105.721C59.7323 105.721 63.6346 106.853 66.2005 109.031C68.7507 111.196 70.0638 114.466 70.0638 118.937C70.0638 123.09 68.8469 126.333 66.457 128.726C64.0728 130.988 60.6443 132.154 56.0959 132.154C51.408 132.154 47.7022 131.105 44.9315 129.058C42.1748 127.02 40.8128 124.349 40.8128 121.004V120.502L40.3103 120.504L1.60402 120.692L1.10645 120.695V121.192V123.447C1.10645 137.363 6.11206 148.348 16.1384 156.344L16.1414 156.346C26.1536 164.204 39.93 168.102 57.4112 168.102C74.3925 168.102 87.9752 164.329 98.1086 156.729C108.287 149.095 113.34 137.34 113.34 121.568C113.34 107.282 108.339 95.8026 98.3238 87.1811C88.4582 78.5809 76.6909 74.2822 63.048 74.2822Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3552_32434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 30,
    width: 112,
    height: 138
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.048 74.7822C76.5765 74.7822 88.2259 79.0412 97.9964 87.5591C107.892 96.077 112.84 107.413 112.84 121.568C112.84 137.226 107.83 148.813 97.8086 156.329C87.7875 163.844 74.3217 167.602 57.4112 167.602C39.9996 167.602 26.3459 163.719 16.4501 155.953C6.55434 148.061 1.60645 137.226 1.60645 123.447V121.192L40.3128 121.004C40.3128 124.512 41.7533 127.33 44.6343 129.46C47.5154 131.589 51.3359 132.654 56.0959 132.654C60.7307 132.654 64.3007 131.464 66.8059 129.084C69.3112 126.579 70.5638 123.196 70.5638 118.937C70.5638 109.793 65.1775 105.221 54.4049 105.221C48.3922 105.221 43.7575 107.1 40.5007 110.858H6.6796L11.7528 30.627H104.949V65.7633H46.5133L45.7617 77.037C50.647 75.5338 56.4091 74.7822 63.048 74.7822Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3552_32434)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3552_32434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8149 105.668C3.45385 102.036 4.50858 89.8458 3.3569 83.6821C1.85184 75.0651 -0.579207 55.9267 1.73715 48.3085C4.6326 38.7856 22.2945 31.2367 32.4595 27.3239C42.6244 23.4111 70.7311 25.5654 77.127 32.3716C83.5229 39.1779 78.4223 58.6374 70.8349 68.1615C63.2474 77.6856 52.8027 67.9824 50.4567 67.9831C48.1107 67.9837 36.2434 70.563 33.5309 76.1297C30.8184 81.6964 29.489 98.2569 25.0292 106.216C20.5693 114.175 18.176 109.3 10.8149 105.668Z",
    fill: "#3538CD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0615 66.5149L82.8691 39.6484",
    stroke: "url(#paint0_linear_3552_32434)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37451 111.106L42.1821 84.2393",
    stroke: "url(#paint1_linear_3552_32434)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_3552_32434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.048 74.7822C76.5765 74.7822 88.2259 79.0412 97.9964 87.5591C107.892 96.077 112.84 107.413 112.84 121.568C112.84 137.226 107.83 148.813 97.8086 156.329C87.7875 163.844 74.3217 167.602 57.4112 167.602C39.9996 167.602 26.3459 163.719 16.4501 155.953C6.55434 148.061 1.60645 137.226 1.60645 123.447V121.192L40.3128 121.004C40.3128 124.512 41.7533 127.33 44.6343 129.46C47.5154 131.589 51.3359 132.654 56.0959 132.654C60.7307 132.654 64.3007 131.464 66.8059 129.084C69.3112 126.579 70.5638 123.196 70.5638 118.937C70.5638 109.793 65.1775 105.221 54.4049 105.221C48.3922 105.221 43.7575 107.1 40.5007 110.858H6.6796L11.7528 30.627H104.949V65.7633H46.5133L45.7617 77.037C50.647 75.5338 56.4091 74.7822 63.048 74.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.048 74.2822C56.6829 74.2822 51.1006 74.9692 46.3085 76.3523L46.9811 66.2633H104.949H105.449V65.7633V30.627V30.127H104.949H11.7528H11.2834L11.2538 30.5954L6.1806 110.826L6.14699 111.358H6.6796H40.5007H40.729L40.8785 111.185C44.0206 107.56 48.5041 105.721 54.4049 105.721C59.7323 105.721 63.6346 106.853 66.2005 109.031C68.7507 111.196 70.0638 114.466 70.0638 118.937C70.0638 123.09 68.8469 126.333 66.457 128.726C64.0728 130.988 60.6443 132.154 56.0959 132.154C51.408 132.154 47.7022 131.105 44.9315 129.058C42.1748 127.02 40.8128 124.349 40.8128 121.004V120.502L40.3103 120.504L1.60402 120.692L1.10645 120.695V121.192V123.447C1.10645 137.363 6.11206 148.348 16.1384 156.344L16.1414 156.346C26.1536 164.204 39.93 168.102 57.4112 168.102C74.3925 168.102 87.9752 164.329 98.1086 156.729C108.287 149.095 113.34 137.34 113.34 121.568C113.34 107.282 108.339 95.8026 98.3238 87.1811C88.4582 78.5809 76.6909 74.2822 63.048 74.2822Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3552_32434",
    x: -73.7671,
    y: -49.1673,
    width: 228.346,
    height: 234.223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.2741,
    result: "effect1_foregroundBlur_3552_32434"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3552_32434",
    x: -4.76198,
    y: 24.2585,
    width: 123.971,
    height: 149.712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.68421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3552_32434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3552_32434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3552_32434",
    x1: 48.2567,
    y1: 66.5148,
    x2: 82.869,
    y2: 39.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3552_32434",
    x1: 7.56968,
    y1: 111.106,
    x2: 42.182,
    y2: 84.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Start);
export default __webpack_public_path__ + "static/media/5__start.1c1fc6e6f86dd24de7e351482985f4bd.svg";
export { ForwardRef as ReactComponent };